import type { TokaMapInstance } from '@tokamap/core';
import React                    from 'react';
import View                     from '@widesk-ui/components/View';
import leftSidebarStore         from '@/TokamapEditor/stores/leftSidebarStore';
import { message }              from '@widesk-ui/hooks/useMessage';
import useDesignTokens          from '@/hooks/useDesignTokens';
import { MAX_SELECTION_SHAPES } from '@/TokamapEditor/ux/constants';

/** Nombre de formes dans la sélection multiple courante (BESOINS.md §13, rectangle de drag) — pas
 * affiché tant qu'aucune sélection multiple n'est active (`@tokamap/core` émet `selection:changed`
 * à chaque changement de composition, voir `MapLibreAdapter`). */
export default function SelectionCount({ instance }: { instance: TokaMapInstance | null }) {
	const [count, setCount] = React.useState(0);
	const tokens = useDesignTokens();

	React.useEffect(() => {
		if (!instance) return;

		return instance.mapAdapter.on((event) => {
			if (event.type === 'selection:limit-exceeded') {
				message.warning(`${event.count} formes : la sélection est limitée à ${event.max}. Réduisez-la.`);
			}
			if (event.type !== 'selection:changed') return;
			setCount(event.shapeIds.length);
		});
	}, [instance]);

	if (count === 0) return null;

	if (count > MAX_SELECTION_SHAPES) {
		return (
			<View px="sm" py={4} color={tokens.color.error} bold>
				{count} formes · {MAX_SELECTION_SHAPES} maximum
			</View>
		);
	}

	return (
		<View
			className="selection-count"
			color="white"
			px="sm"
			py={4}
			pointer
			style={{ borderRadius: 100, textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: 3 }}
			hover={{ bg: '#393A40' }}
			// Inconditionnel : la garde `if (!opened)` d'origine rendait ce libellé inerte dès qu'une
			// sidebar était ouverte — ce qui est devenu le cas courant, la sélection composée depuis une
			// liste (bouton "N zones liées") la laissant désormais en place. Cliquer ici est une demande
			// explicite, elle prime donc sur ce qui est affiché.
			onClick={() => leftSidebarStore.openFeatureSettings()}
		>
			{count} forme{count > 1 ? 's' : ''} sélectionnée{count > 1 ? 's' : ''}
		</View>
	);
}
